import { render, staticRenderFns } from "./VirtualVenue.vue?vue&type=template&id=ef85b3a8&"
import script from "./VirtualVenue.vue?vue&type=script&lang=js&"
export * from "./VirtualVenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports